/**
 * Ce que le centre pose lui-même dans les fentes du design system : le calque de dessin d'une surface
 * (`<AnnotationCanvas>`, la fente `annotation` de `<TutorLiveActivityView>`) et la boîte « Modifier le
 * titre » (la fente `sheet` du calque de la salle : le dialogue `custom` n'a pas de champ).
 *
 * À part des crochets pour qu'ils restent testables sous Jest (Unistyles ne s'y charge pas : les tests
 * remplacent ce module).
 */
import React from "react"

import {
    AnnotationCanvas,
    type AnnotationCanvasProps,
} from "../../../../../../design-system/molecules/AnnotationCanvas"
import { Button } from "../../../../../../design-system/atoms/Buttons/Button"
import { TextInput } from "../../../../../../design-system/atoms/TextInput"
import { Modal } from "../../../../../../design-system/molecules/Modal"

export function renderAnnotationCanvas(props: AnnotationCanvasProps): React.ReactNode {
    return <AnnotationCanvas {...props} />
}

export type TitleEditorProps = {
    value: string
    onChange: (value: string) => void
    onSave: () => void
    onCancel: () => void
    saving: boolean
}

const TEXTS = {
    title: "Modifier le titre",
    label: "Titre de l'activité",
    placeholder: "Entrer le titre...",
    save: "Enregistrer",
}

/**
 * « Modifier le titre » (`EditActivityTitleModal`) : le champ prérempli, « Enregistrer ». Le titre vide se
 * refuse au geste, par une snackbar, comme l'ancien (le bouton reste donc touchable).
 */
export function renderTitleEditor(props: TitleEditorProps): React.ReactNode {
    const { value, onChange, onSave, onCancel, saving } = props
    return (
        <Modal
            visible
            onClose={onCancel}
            title={TEXTS.title}
            fitContent
            footer={<Button label={TEXTS.save} fullWidth loading={saving} disabled={saving} onPress={onSave} />}
        >
            <TextInput
                label={TEXTS.label}
                value={value}
                onChangeText={onChange}
                placeholder={TEXTS.placeholder}
                autoFocus
            />
        </Modal>
    )
}
